import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/hooks';
import { updateGeneralTicketTemplate } from '../../../../state';

/**
 * RecurringTaskGeneralTicketDescriptionEditor - Editor for the ticket description that will be used when creating tickets
 * This is separate from the recurring task's own description
 */
export const RecurringTaskGeneralTicketDescriptionEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const recurringTask = useAppSelector(state => state.recurringTask.currentRecurringTask);

  const handleChange = (value: string) => {
    dispatch(updateGeneralTicketTemplate({ ticketDescription: value }));
  };

  return (
    <TextField
      label="Ticket Description"
      value={recurringTask?.generalTicketTemplate?.ticketDescription || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      required
      multiline
      rows={4}
      placeholder="Enter the description for tickets created from this template"
      helperText="This description will be used for all tickets created from this recurring task"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <DescriptionOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default RecurringTaskGeneralTicketDescriptionEditor;
